import {
  IconAward,
  IconBrandFacebook,
  IconBrandGoogle,
  IconBrandMeta,
  IconBrandTiktok,
  IconBrandWhatsapp,
  IconClick,
  IconCreditCard,
  IconDeviceTablet,
  IconEye,
  IconGlobe,
  IconHandClick,
  IconMail,
  IconMessage,
  IconMoneybag,
  IconPhone,
  IconRobot,
  IconShoppingCart,
  IconStar,
  IconUserMinus,
  IconUserPlus,
  IconUsers,
  IconWebhook,
  IconWindowMaximize,
} from '@tabler/icons-react';

const SummaryCardsIcons = {
  recommender: { icon: IconAward, tablerIcon: <IconAward size={16} /> },
  facebook: { icon: IconBrandFacebook, tablerIcon: <IconBrandFacebook size={16} /> },
  meta: { icon: IconBrandMeta, tablerIcon: <IconBrandMeta size={16} /> },
  google: { icon: IconBrandGoogle, tablerIcon: <IconBrandGoogle size={16} /> },
  tiktok: { icon: IconBrandTiktok, tablerIcon: <IconBrandTiktok size={16} /> },
  ads: { icon: IconClick, tablerIcon: <IconClick size={16} /> },
  salesAgent: { icon: IconRobot, tablerIcon: <IconRobot size={16} /> },
  productBlock: { icon: IconAward, tablerIcon: <IconAward size={16} /> },
  facebookAd: { icon: IconBrandFacebook, tablerIcon: <IconBrandFacebook size={16} /> },
  googleAd: { icon: IconBrandGoogle, tablerIcon: <IconBrandGoogle size={16} /> },
  banner: { icon: IconWindowMaximize, tablerIcon: <IconWindowMaximize size={16} /> },
  email: { icon: IconMail, tablerIcon: <IconMail size={16} /> },
  pushNotification: { icon: IconDeviceTablet, tablerIcon: <IconDeviceTablet size={16} /> },
  pushNotificationSubscribers: { icon: IconDeviceTablet, tablerIcon: <IconDeviceTablet size={16} /> },
  viberMessage: { icon: IconPhone, tablerIcon: <IconPhone size={16} /> },
  textMessage: { icon: IconMessage, tablerIcon: <IconMessage size={16} /> },
  subscribes: { icon: IconUserPlus, tablerIcon: <IconUserPlus size={16} /> },
  unsubscribes: { icon: IconUserMinus, tablerIcon: <IconUserMinus size={16} /> },
  subscribers: { icon: IconUsers, tablerIcon: <IconUsers size={16} /> },
  registered: { icon: IconUsers, tablerIcon: <IconUsers size={16} /> },
  totalSubscribed: { icon: IconUsers, tablerIcon: <IconUsers size={16} /> },
  totalRegistered: { icon: IconUsers, tablerIcon: <IconUsers size={16} /> },
  emailSends: { icon: IconMail, tablerIcon: <IconMail size={16} /> },
  pushSends: { icon: IconDeviceTablet, tablerIcon: <IconDeviceTablet size={16} /> },
  viberMessageSends: { icon: IconPhone, tablerIcon: <IconPhone size={16} /> },
  textMessageSends: { icon: IconMessage, tablerIcon: <IconMessage size={16} /> },
  productBlockClicks: { icon: IconAward, tablerIcon: <IconAward size={16} /> },
  productBlockPurchases: { icon: IconAward, tablerIcon: <IconAward size={16} /> },
  bannerClicks: { icon: IconWindowMaximize, tablerIcon: <IconWindowMaximize size={16} /> },
  bannerPurchases: { icon: IconWindowMaximize, tablerIcon: <IconWindowMaximize size={16} /> },
  pageViews: { icon: IconEye, tablerIcon: <IconEye size={16} /> },
  assistedPageViews: { icon: IconEye, tablerIcon: <IconEye size={16} /> },
  cartCreates: { icon: IconShoppingCart, tablerIcon: <IconShoppingCart size={16} /> },
  cartAdds: { icon: IconShoppingCart, tablerIcon: <IconShoppingCart size={16} /> },
  purchases: { icon: IconCreditCard, tablerIcon: <IconCreditCard size={16} /> },
  default: { icon: IconGlobe, tablerIcon: <IconGlobe size={16} /> },
  releva: { icon: IconStar, tablerIcon: <IconStar size={16} /> },
  topBadge: { icon: IconStar, tablerIcon: <IconStar size={16} /> },
  engagement: { icon: IconHandClick, tablerIcon: <IconHandClick size={16} /> },
  webEngagement: { icon: IconHandClick, tablerIcon: <IconHandClick size={16} /> },
  conversions: { icon: IconMoneybag, tablerIcon: <IconMoneybag size={16} /> },
  relevaFacebookAd: { icon: IconBrandFacebook, tablerIcon: <IconBrandFacebook size={16} /> },
  whatsappMessage: { icon: IconBrandWhatsapp, tablerIcon: <IconBrandWhatsapp size={16} /> },
  whatsappMessageSends: { icon: IconBrandWhatsapp, tablerIcon: <IconBrandWhatsapp size={16} /> },
  webhookSends: { icon: IconWebhook, tablerIcon: <IconWebhook size={16} /> },
  emailClicks: { icon: IconMail, tablerIcon: <IconMail size={16} /> },
  pushNotificationClicks: { icon: IconDeviceTablet, tablerIcon: <IconDeviceTablet size={16} /> },
  textMessageClicks: { icon: IconMessage, tablerIcon: <IconMessage size={16} /> },
  viberMessageClicks: { icon: IconPhone, tablerIcon: <IconPhone size={16} /> },
  whatsappMessageClicks: { icon: IconBrandWhatsapp, tablerIcon: <IconBrandWhatsapp size={16} /> },
  salesAgentClicks: { icon: IconRobot, tablerIcon: <IconRobot size={16} /> },
  searchClicks: { icon: IconGlobe, tablerIcon: <IconGlobe size={16} /> },
};

export default SummaryCardsIcons;
